import React,{ useEffect, useState, useContext }  from 'react';
import { useSortable } from "@dnd-kit/sortable";
import './Components.css';
import { CSS } from '@dnd-kit/utilities';
import { MasterCapabilitiesList, LMList } from '../utils/LMConstants';
import { StarIcon, StarIconEmpty } from '../icons/Icons';
import { ThemeContext } from '../contexts/AppContext';

function MiniWidget({ id, title, value, unit, std, avg, launchmonitor, isFavorite, SetFavorite }) {

    const { theme, setAppTheme } = useContext(ThemeContext);
    const [currentTheme, setCurrentTheme] = useState(theme);

    const isEmpty = !launchmonitor;

    useEffect(() => {
        setCurrentTheme(theme);
        }, [theme]);

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? "100" : "1",
        opacity: isDragging ? 0.3 : 1,
        backgroundColor: isEmpty ? 'transparent' : getComputedStyle(document.documentElement).getPropertyValue('--background-secondary')
    };

    const lmTitleStyle = {
        backgroundColor: !isEmpty ? LMList.find(l => l.type === launchmonitor).color : 'transparent',
        width: "100%"
    };

    function FavoriteButton() {
        if (isFavorite) {
            return <StarIcon />;
        } else {
            return <StarIconEmpty />;
        }
    }

    return (
        <>
        {isEmpty && (
            <div ref={setNodeRef} style={{ position: 'relative', padding: '10px' }}>
              <div className="widget" style={style}>
              </div>
          </div>
        )}
        <></>
        {!isEmpty && (
            <div ref={setNodeRef} style={{ position: 'relative', padding: '10px' }}>
            {(!isEmpty && !isDragging && SetFavorite !== undefined) && (
                      <button
                          className="widget-button"
                          style={{ background: 'transparent' }}
                          onClick={(e) => {
                              e.stopPropagation(); // Prevent click from propagating
                              SetFavorite(id); // Call the favorite handler
                          }}
                      >
                          {FavoriteButton()}
                      </button>
                  )}
              <div className="widget-mini" style={style} {...attributes} {...listeners}>
                  <div className='widget-lm' style={lmTitleStyle}>{title}</div>
                  <div className="widget-value">{value}</div>
                  <div className='widget-footer'>
                      <div className="widget-foot" style={{fontSize:'0.8em', paddingLeft:'7px'}}>{avg ? avg : '--'}</div>
                      <div className="widget-unit" style={{fontSize:'0.9em', margin:'0 auto'}}>{unit}</div>
                      <div className="widget-foot" style={{fontSize:'0.8em', paddingRight:'7px'}}>{"±" + (std ? std : '--')}</div>
                  </div>
              </div>
          </div>
        )}
        </>
    );
}

export default MiniWidget;
